import { useState } from "react";
import { format, parse, isValid } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

// Drop-in replacement for <input type="date"> that lets you jump years/months
// via dropdowns. value/onChange use "yyyy-MM-dd" strings.
export function DatePicker({
  value,
  onChange,
  testid,
  disabled = false,
  placeholder = "Select date",
  fromYear = 1930,
  toYear = new Date().getFullYear() + 20,
}) {
  const [open, setOpen] = useState(false);
  const parsed = value ? parse(value, "yyyy-MM-dd", new Date()) : undefined;
  const selected = parsed && isValid(parsed) ? parsed : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          data-testid={testid}
          disabled={disabled}
          className={cn(
            "w-full justify-start text-left font-normal h-10 border-slate-200",
            !selected && "text-slate-400"
          )}
        >
          <CalendarIcon className="mr-2 h-4 w-4 opacity-60 shrink-0" />
          {selected ? format(selected, "dd MMM yyyy") : <span>{placeholder}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={selected}
          defaultMonth={selected}
          captionLayout="dropdown-buttons"
          fromYear={fromYear}
          toYear={toYear}
          onSelect={(d) => {
            onChange(d ? format(d, "yyyy-MM-dd") : "");
            setOpen(false);
          }}
        />
      </PopoverContent>
    </Popover>
  );
}
